const memberServicePath = 'member-service/v2';
const memberServiceAccountPath = '/member-service/v2/account';
const oddsServicePath = 'sports-service/sv';
const betServicePath = 'bet-placement';
const vsServicePath = 'vs-service';
const templateServicePath = 'esthardsk/data-resoures/template-layout';
const paymentServicePath = '/payment/web';
const iforiumServicePath = '/iforium-service';
const solidGameLaunchPath = 'sg/get-game-launch-url';
const captchaServicePath = '/captcha-mgmt';
const liveCenterServicePath = '/live-center-service/s';
const liveTVServicePath = '/live-center-service/s/live-streaming';
const liveScoreServicePath = '/livescore-notifier';

const WagerMode = {
    DANGER_ZONE: 'dz',
    LIVE_DELAY: 'ld'
}
const APIS = {

    /**
     * get member-service path
     */
    getMemberServicePath: function () {
      return memberServicePath;
    },
    
    /**
     * template-service
     */
    templateLoadURL: function () {
        let url = `${memberServicePath}/config`; //from server
        return url;
    },

     /**
     * template-service
     */
    loadingTemplateURL: function () {
        let url = `${memberServicePath}/load-template`; //from server
        return url;
    },

    templateLoadURLLocal: function (skinName) {
        let url = `${templateServicePath}/${skinName}.json`; //from local
        return url;
    },

    /**
     * member-service
     */
    memberLoginURL: function () {
        return `${memberServicePath}/login`;
    },
    memberLogoutURL: function () {
        return `${memberServicePath}/logout`;
    },

    accountBalanceURL: function () {
        return `${memberServicePath}/account-balance`;
    },

    getSumAnnouncementUnreadURL: function () {
      return `${memberServicePath}/get-sum-announcement-unread`;
    },

    preferencesURL: function () {
        return `${memberServicePath}/preferences`;
    },

    listTimeZonesURL: function () {
        return `${memberServicePath}/list-time-zones`;
    },

    sportsSortingURL: function (country) {
        return `${memberServicePath}/sports-sorting?$c=${country}`;
    },
    
    postSportsSortingURL: function () {
        return `${memberServicePath}/sports-sorting`;
    },

    dataNoCache: function () {
        return `${memberServicePath}/data.nocache`;
    },

    mybetURL: function () {
        return `${memberServicePath}/my-bets`;
    },

    oddsSelectionsURL: function () {
        return `${memberServicePath}/odds-selections`;
    },

    oddsSelectionsUpdateURL: function () {
        return `${memberServicePath}/odds-selections-update`;
    },

    allOddsSelectionsURL: function () {
        return `${memberServicePath}/all-odds-selections`;
    },

    allOddsSelectionsUpdateURL: function () {
        return `${memberServicePath}/all-odds-selections-update`;
    },

    announcementURL: function () {
        return `${memberServicePath}/announcement/list-limit`;
    },

    getAllAnnouncements: function (dataQueryParam) {
        return `${memberServicePath}/message/all?${dataQueryParam}&pageNo=1`;
    },

    getMaintenanceAnnouncements: function (dataQueryParam) {
      return `${memberServicePath}/announcement/list?${dataQueryParam}&page=1`;
    },

    getLoginMessage: () => {
      return `${memberServicePath}/message/getLoginMessage`;
    },

    readLoginMessage: () => {
      return `${memberServicePath}/message/readLoginMessage`;
    },

    getMessages: (dataQueryParam) => {
      return `${memberServicePath}/message/list?${dataQueryParam}`;
    },

    getUnhiddenMessagesList: (dataQueryParam) => {
      return `${memberServicePath}/message/listUnhidden?${dataQueryParam}`;
    },

    getInboxMessageList: (dataQueryParam) => {
      return `${memberServicePath}/message/listInboxMessage?${dataQueryParam}`;
    },

    deleteMessage: `${memberServicePath}/message/delete`,

    undoMessage: `${memberServicePath}/message/undo`,

    deleteAnnouncement: `${memberServicePath}/announcement/delete`,

    undoAnnouncement: `${memberServicePath}/announcement/undo`,

    getLastMessageURL: function () {
        return `${memberServicePath}/message/lastMessage`;
    },
    updateMessageToRead: () => {
      return `${memberServicePath}/message/update-inbox-message-to-read`;
    },

    updateAnnouncementToRead: () => {
      return `${memberServicePath}/message/update-announcement-to-read`;
    },

    /**
     * promotion service
     */
    getPromotionInfo: function (lng) {
        return `${memberServicePath}/slider/getPromotionInfo?lang=${lng}`;
    },

    validateWelcomeBonus: function() {
      return `${memberServicePath}/bonusPromotion/validateWelcomeBonus`;
    },

    validateReactivationBonus: function() {
      return `${memberServicePath}/bonusPromotion/validateReactivationBonus`;
    },

    validateCashbackRebateBonus: function() {
      return `${memberServicePath}/bonusPromotion/validateCashbackRebateBonus`;
    },

    claimWelcomeBonus: function() {
      return `${memberServicePath}/bonusPromotion/claimWelcomeBonus`;
    },

    claimReactivationBonus: function() {
      return `${memberServicePath}/bonusPromotion/claimReactivationBonus`;
    },

    claimCashbackRebate: function() {
      return `${memberServicePath}/bonusPromotion/claimCashbackRebate`;
    },

    /** end */

    reportSystemErrorURL: function () {
        return `${memberServicePath}/report-system-error`;
    },

    acceptTCURL: function(promoEmail, version) {
        return `${memberServicePath}/acceptTC?promoEmail=${promoEmail}&version=${version}`
    },

    acceptNewMobileBetslip: function() {
      return `${memberServicePath}/mobile/new-betslip/accept-popup`
  },

    memberGetCountryAndCurrency: function() {
        return `${memberServicePath}/register/CountryAndCurrency?c=Others`
    },

    memberRefreshCaptcha: function() {
        return `${memberServicePath}/captcha?${new Date().getTime()}`
    },

    getCaptchaImage: function(category) {
        return `${captchaServicePath}/captcha/get?category=${category}&${new Date().getTime()}`
    },
    
    activationLink: function() {
        return `${memberServicePath}/register/rq_activation_link?originUrl=${window.location.origin}`
    },

    memberDoForgotUsername: function() {
        return `${memberServiceAccountPath}/doForgotUsername`
    },
    
    memberDoForgotEmail: function() {
        return `${memberServiceAccountPath}/doForgotEmail`
    },

    memberDoForgotPassword: function() {
        return `${memberServiceAccountPath}/doForgetPassword`
    },
    memberCheckLoginId: function() {
        return `${memberServicePath}/register/check-loginId`
    },
    memberDoSignUp: function() {
        return `${memberServicePath}/register/doSignup`
    },
    memberGetBanks: function() {
        return `${memberServicePath}/register/get-banks`
    },
    memberGetWallets: function() {
        return `${memberServicePath}/register/get-wallets`
    },
    memberGetActivePayments: function() {
        return `${paymentServicePath}/bank/get-all-pc-active-deposit-payment-type`
    },

    memberGetSupportedPaymentTypes: function() {
        return `${paymentServicePath}/bank/get-supported-payment-type`
    },

    memberGetPinPayPaymentMethods: function() {
        return `${paymentServicePath}/bank/get-supported-payment-methods`
    },

    memberGetPinPaySupportedBanks: function() {
        return `${paymentServicePath}/bank/get-supported-banks`
    },

    memberAddBankingAccount: function() {
        return `${paymentServicePath}/bank/add`
    },

    esportMarketURL: function (country, v) {
        return `${oddsServicePath}/menu/esport-market?c=${country}&v=${v}`;
    },

    classicSportsMarketURL: function (country) {
    const wm = WagerMode[window.wagerMode] || '';
      return `${oddsServicePath}/menu/classic-sports-markets?c=${country}&wm=${wm}`;
    },
    /**
     * bet-placement
     */

    betPlacementBuyURL: function (uniqueRequestId) {
        return `${betServicePath}/buyV2?uniqueRequestId=${uniqueRequestId}`;
    },

    betPlacementMultiBuyURL: function (uniqueRequestId) {
        return `${betServicePath}/multiBuyV1?uniqueRequestId=${uniqueRequestId}`;
    },

    /**
     * vs-service
     */
    startBetURL: function (uniqueRequestId) {
        return `${vsServicePath}/game/start-bet`;
    },

    /**
     * Get teaser ticket url
     */
    getTeaserTicketURL: (params) => {
        return `${memberServicePath}/teaser-ticket?teaserId=${params.teaserId}&ticketId=${params.ticketId}&oddsFormat=${params.oddsFormat}&legs=${params.legs}`;
    },

    /**
     * Get MyBets Data URL
     */
    getMyBetsURL: () => {
        return `${memberServicePath}/my-bets`;
    },
    /**
     * get DeleteMyBetsWager
     */
    getDeleteMyBetsWager: (wagerId) => {
        return `${memberServicePath}/delete-wager?wagerId=${wagerId}`;
    },

    /**
     * Get Classic Outright odds URL
     */
    outrightOddsClassicURL: function (dataQueryParam) {
        const keyQueryOutrightForEsport = 'eSportCode';
        const match = RegExp('[?&]' + keyQueryOutrightForEsport + '=([^&]*)').exec(dataQueryParam);
        if (match && decodeURIComponent(match[1].replace(/\+/g, ' '))) {
          return `${oddsServicePath}/outRight/esport/odds/classic?${dataQueryParam}`;
        }
        return `${oddsServicePath}/outRight/odds/classic?${dataQueryParam}`;
      },

    /**
     * Get teaser odds URL
     */
    teaserOddsURL: function (dataQueryParam) {
        return `${oddsServicePath}/teaser/oddsAdvance?${dataQueryParam}`;
    },

    /**
     * Remove teaser ticket url
     */
    removeTeaserTicketURL: (params) => {
        return `${memberServicePath}/remove-teaser-ticket?teaserId=${params.teaserId}&ticketId=${params.ticketId}&oddsFormat=${params.oddsFormat}&legId=${params.legId}`;
    },

    /**
     * Buy teaser bet URL
     */
    buyTeaserBetURL: function (uniqueRequestId) {
        return `${betServicePath}/buyTeaserV2?uniqueRequestId=${uniqueRequestId}`;
    },

    parlayRemoveSelectionsURL: (legId) => {
        return `${memberServicePath}/parlay-remove-selection?legId=${legId}`;
    },

    parlayOddsSelectionsURL: function () {
        return `${memberServicePath}/parlay-odds-selections`;
    },

    parlayUpdateOddsURL: function () {
        return `${memberServicePath}/parlay-update-odds`;
    },

    placeParlayBetURL: (uniqueRequestId) => {
        return `${betServicePath}/buyParlayV2?uniqueRequestId=${uniqueRequestId}`;
    },

    updatePitcherParlayURL: (params) => {
        return `${memberServicePath}/update-pitcher-parlay-ticket?legId=${params.legId}&pitcher1MustStart=${params.pitcher1MustStart}&pitcher2MustStart=${params.pitcher2MustStart}`;
    },

    /**
     * Update fresh id URL
     */
    updateFreshIdURL: () => {
      return `${memberServicePath}/updateFreshId`;
    },

    getSliderBannerHomeURL: (params) => {
        return `${memberServicePath}/slider/getSliderBannerHome?lang=${params.lang}&c=${params.country}`
    },

    getAllMiniBannerURL: (params) => {
        return `${memberServicePath}/single/getAllMiniBanner?lang=${params.lang}&country=${params.country}`;
    },

    /**
     * Classic View
     */
    getClassicSportsMarkets: (sportId, leagueId, market, eventId)  => {
        const wm = WagerMode[window.wagerMode] || '';
        return `${oddsServicePath}/classic/sport-markets?sportId=${sportId}&lg=${leagueId}&mk=${market}${eventId ? '&ev=' + eventId : ''}&wm=${wm}`;
    },

    getClassicEventOdds: (sportId, leagueId, market, marketType, oddsType, maxLines, eventId, order, version, timeZoneId, isAuth)  => {
        const wm = WagerMode[window.wagerMode] || '';
        let liveVersion, nonLiveVersion;
        if(market == 2) {
            nonLiveVersion  = version[0];
        } else {
            liveVersion = version[0];
            nonLiveVersion = version[1];
        }
        return `${oddsServicePath}/classic/events?wm=${wm}&sp=${sportId}&lg=${leagueId}&mk=${market}&l=${maxLines}&smt=${marketType}&ot=${oddsType}
            &o=${order}&_g=${isAuth ? 0 : 1}${eventId ? '&ev=' + eventId : ''}${liveVersion ? '&lv=' + liveVersion : ''}&tz=${timeZoneId}${nonLiveVersion ? '&v=' + nonLiveVersion : ''
        }`;
    },

    getClassicParlayEventOdds: (sportIds, leagueIds, market, oddsType, maxLines, isParlay, order, date, version, timeZoneId, isAuth) => {
        const wm = WagerMode[window.wagerMode] || '';
      return `${oddsServicePath}/classic/events?wm=${wm}&sp=${sportIds}&lg=${leagueIds}&l=${maxLines}&mk=${market}&ot=${oddsType}&pa=${isParlay}&o=${order}&tz=${timeZoneId}&_g=${isAuth ? 0 : 1}${version ? '&v=' + version : ''}${date ? '&d=' + date : ''}`;
    },

    /**
     * Canino
     * Get category
     */
    getCategory: () => {
      return `${memberServicePath}/casino/category`;
    },

    /**
     * Canino
     * Get Live category
     */
    getLiveCategory: () => {
        return `${memberServicePath}/casino/live/category`;
      },
  

    /**
     * Canino
     * update Casino Favourites
     */
    updateCasinoFavourites: () => {
        return `${memberServicePath}/casino/update-casino-favorites`;
    },

    /**
     * 
     * close game Casino
     */
    updateCloseGameCasino: () => {
      return `${memberServicePath}/casino/close-game`;
    },

     /**
     * Canino
     * get Casino Favourites
     */
    getCasinoFavourites: () => {
        return `${memberServicePath}/casino/get-casino-favorites`;
    },

    /**
     * Get Casino sliders
     */
    getCasinoSlider: (casinoSliderFilter) => {
      return `${memberServicePath}/slider/getCasinoSlider?${casinoSliderFilter}`;
    },

    /**
     * Get Casino games
     */
    getCasinoGames: (casinoFilter) => {
      return `${memberServicePath}/casino/games?${casinoFilter}`;
    },

    /**
     * Get Iforium providers
     */
    getIforiumProviders: () => {
      return `${iforiumServicePath}/game/providers`;
    },

     /**
     * Canino - get Casino side bar
     */
    getCasinoSideBar: () => {
        return `${memberServicePath}/casino/getCasinoSideBars`;
    },

    /**
     * Canino - initGameflexExpressLibrayAPI
     */
    initGameflexExpressLibray: () => {
        return `${iforiumServicePath}/game/getGameflexExpressConfig`;
    },

    /**
     * Casino - Solid game launch path
     */
    getSolidGameLaunchPath: function(gameCode) {
      return `${memberServicePath}/${solidGameLaunchPath}/${gameCode}`;
    },

    /**
     * Canino - getPlayerCurrencyCode
     */
    getPlayerCurrencyCode: () => {
        return `${iforiumServicePath}/player/getCurrencyCode`;
    },

    /**
     * Canino - getPlayerSession
     */
    getPlayerSession: () => {
        return `${iforiumServicePath}/player/sessiontoken`;
    },

    /**
     * Golden race Vs - getPlayerSession
     */
    getPlayerSessionVs: () => {
        return `${iforiumServicePath}/player/sessiontokenvs`;
    },

    /**
     * Golden race Vs - getDefaultGameIdGRVs
     */
    getDefaultGameIdGRVs: (channelId) => {
      return `${memberServicePath}/casino/default-game-gr?${channelId}`;
    },

    /**
     * Get accounts balance
     */
    getAccountsBalance: () => {
      return `${memberServicePath}/accounts-balance`;
    },

    /**
     * Transfer wallets
     */
    transferWallets: () => {
      return `${paymentServicePath}/transfer/process`;
    },
    
    /**
     * Transfer ata wallets
     */
    ataTransferWallets: () => {
      return `${paymentServicePath}/transfer/ata-process`;
    },

    /**
     * Authorize ata wallets
     */
    ataAuthorize: () => {
        return `${paymentServicePath}/transfer/ata-authorize`;
    },

     /**
     * Get game dispatcher Url
     */
    getGameDispatcherUrl: (dataQueryParam) => {
      return `${memberServicePath}/getGameDispatcherUrl?${dataQueryParam}`;
    },

    /**
     * Get AG game dispatcher Url
     */
    getAGGameDispatcherUrl: (dataQueryParam) => {
      return `${memberServicePath}/getAGGameDispatcherUrl?${dataQueryParam}`;
    },

    /**
     * Get casino login status
     */
    getCasinoLoginStatus: () => {
      return `${memberServicePath}/getCasinoLoginStatus`;
    },

    /**
     * Get CR855 game path
     */
    getCR855GamePath: function () {
      return `${memberServicePath}/crown-service/login`;
    },

    /**
     * Check Playtech player online
     */
    checkPlaytechPlayerOnline: () => {
      return `${memberServicePath}/p/playtech-service/player/online`;
    },

    /**
     * Get playtech player
     */
    getPlaytechPlayer: () => {
      return `${memberServicePath}/playtech-service/login`;
    },

    /**
     * Get Casino Backround
     */
    getCasinoBackground: (dataQueryParam) => {
      return `${memberServicePath}/single/getCasinoBanner?${dataQueryParam}`;
    },

    /**
     * Get active product wallet
     */
    getActiveProductWallet: () => {
      return `${memberServicePath}/getActiveProductWallet`;
    },

    /**
     * Check Affiliate Code
     */
    checkAffiliateCode: () => {
      return `${memberServicePath}/register/check-affiliate`;
    },

    /**
     * Check Promo Code
     */
    checkPromoCode: () => {
        return `${memberServicePath}/register/doValidatePromotionCode`;
    },

    /**
     * Update locale
     */
    updateLocale : (lang) => {
        return `${memberServicePath}/locale?lang=${lang}`;
    },
    
    /**
     * Update Display Mode
     */
    updateDisplayMode : (displayMode) => {
        return `${memberServicePath}/displayMode?displayMode=${displayMode}`;
    }, 

    updateDefaultView : (view) => {
        return `${memberServicePath}/updateDefaultView?defaultView=${view}`;
    }, 

    getLiveCasinoGames: (casinoFilter) => {
        return `${memberServicePath}/casino/live/games?${casinoFilter}`;
    },

    getMaintenanceTemplate: () => {
      return `${memberServicePath}/getMaintenanceByLang`;
    },
    
    oddsEventsURL: (dataQueryParam) => {
        return `${oddsServicePath}/am/events?${dataQueryParam}`;
    },

    oddsCompactEventsURL: (dataQueryParam) => {
      return `${oddsServicePath}/compact/events?${dataQueryParam}`;
    },

    oddsCompactFavouriteEventsURL: (dataQueryParam) => {
        return `${oddsServicePath}/compact/favourite-events?${dataQueryParam}`;
    },

    asiaSportsMarketURL: (country, v) => {
      const wm = WagerMode[window.wagerMode] || '';
      return `${oddsServicePath}/compact/sports-markets?c=${country}&v=${v}&wm=${wm}`;
    },

    compactSpecialLeaguesURL: (country, v) => {
      const wm = WagerMode[window.wagerMode] || '';
      return `${oddsServicePath}/compact/special-leagues?c=${country}&v=${v}&wm=${wm}`;
    },

    virtualSportURL: () => {
      return `${vsServicePath}/game/start-bet`
    },

    favouriteSportURL: (eventsId) => {
      return `${oddsServicePath}/menu/favouriteSports?eventIds=${eventsId}`;
    },

    compactFavouriteSportURL: (eventsId, leaguesId) => {
      return `${oddsServicePath}/compact/favourite?eventIds=${eventsId}&leagueIds=${leaguesId}`;
    },

    /**
     * Get outright leagues
     */
    
    getOutrightLeaguesURL: (parameters) => {
      return `${oddsServicePath}/compact/outright/leagues?${parameters}`;
    },

    /**
     * Get normal leagues
     */
    getLeaguesURL: (parameters) => {
      return `${oddsServicePath}/odds/leagues?${parameters}`;
    },

    /**
     * Get normal leagues
     */
     getCompactLeaguesURL: (parameters) => {
      return `${oddsServicePath}/compact/leagues?${parameters}`;
    },

    /**
     * Get esport leagues
     */
    getEsportLeaguesURL: (esportParams) => {
      return `${oddsServicePath}/compact/es-leagues?${esportParams}`;
    },

    /**
     * Get Outright odds URL
     */
    outrightOddsURL: function (dataQueryParam) {
      return `${oddsServicePath}/compact/outright?${dataQueryParam}`;
    },

    /**
     * Get statement info
     */
    getStatement: function(params) {
        return `${memberServicePath}/statement2?${params}`;
    },

    /**
     * Get transaction info
     */
    getTransactions: function() {
        return `${memberServicePath}/transactions`;
    },

    /**
     * Get eSport Outright odds URL
     */
    esportOutrightOddsURL: function (dataQueryParam) {
      return `${oddsServicePath}/compact/e-sport/outright?${dataQueryParam}`;
    },

    updateParlayTicketURL: (params) => {
      return `${memberServicePath}/update-parlay-ticket?${params}`;
    },

    getAllLiveCenterEventsURL: (liveCenterSeverPath, params) => {
      return `${liveCenterSeverPath}${liveCenterServicePath}/event/list?${params}`;
    },
    getAllLiveTVEventsURL: (liveCenterSeverPath, params) => {
      return `${liveCenterSeverPath}${liveTVServicePath}/event/list/${params}`;
    },

    getAllEventLivenCenter: (params) => {
      return `${memberServicePath}/live-center/live-events?${params}`;
    },

    getLiveScoreNotifyURL: () => {
        console.log('path socket...', `${liveScoreServicePath}/subscribe.sv`)
        return `${liveScoreServicePath}/subscribe.sv`;
    },

    liverScoreUpdateNotifyURL: (flag) => {
        return `${memberServicePath}${liveScoreServicePath}/update-notify?${flag}`;
    },

    changePassword: () => {
      return `${memberServicePath}/changePasswordToLogin`;
    },
    submitSelfExclusion: () => {
      return `${memberServicePath}/self-excludsion`;
    },
    loadProfile: () => {
      return `${memberServiceAccountPath}/profile`;
    },
    submitBettingBudgets: () => {
      return `${memberServicePath}/betting-budgets`;
    },
    updateProfile: () => {
      return `${memberServiceAccountPath}/updateprofile`;
    },
    updatePassword: () => {
      return `${memberServicePath}/changePassword`;
    },
    loadSecurityQuestion: () => {
      return `${memberServicePath}/get-user-security-question-answer`;
    },
    updateSecurityQuestionAnswer: () => {
      return `${memberServicePath}/update-user-security-question-answer`;
    },
    checkCurrentPassword: () => {
      return `${memberServicePath}/check-current-password`;
    },
    getAccountLoginHistory : () => {
        return `${memberServicePath}/account-login-history`;
    },
    getGenerateCashierURL:(params) => {
        return `${paymentServicePath}/ngc-api/generateUrl?${params}`;
    },
    
    // -- Landing Page START --
    
    fetchBanner: function (params) {
        return `${memberServicePath}/landing?${params}`;
    },

    fetchOdds: function (params) {
      return `${oddsServicePath}/landing-odds?${params}`;
  },
    
    // -- Landing Page END --
    wagerDetailURL: function (params) {
        return `${memberServicePath}/getWagerDetails?${params}`;
    },
    transactionDetailURL: function (params) {
        return `${memberServicePath}/getTransactionDetails?${params}`;
    },

    wagerFilterURL: function () {     
      return `${memberServicePath}/unified-account/wager-filter-all`;
    },

    searchWagerbyIdURL: function () {     
      return `${memberServicePath}/unified-account/search-wager`;
    },

    wagerFilterExportURL: function () {
        return `${memberServicePath}/unified-account/wager-export-all`;
    },

    getProductFilterURL: function () {
        return `${memberServicePath}/getProductFilter`;
    },
    
    getMyBonus: function (params) {
        return `${memberServiceAccountPath}/get-bonuses?dateRange=${params.dateRange}&lang=${params.lang}`;
    },
    getTermAndCondition: function (params) {
        return `${memberServiceAccountPath}/getPromotionInfoById?promotionId=${params.promotionId}&lang=${params.lang}`;
    },
    // -- Landing Page END --

    fetchSideBanner: function (params) {
        return `${memberServicePath}/side-banner?${params}`;
    },


    getActiveLink: (dataQueryParam) => {
      return `${memberServicePath}/register/activation_link?${dataQueryParam}`;
    },

    // -- GDPR END --

    /**
     * Search suggestions 
     */
    searchSuggestionsURL: (dataQueryParam) => {
      return `${oddsServicePath}/search/v2?${dataQueryParam}`;
    },

    searchEventsURL: (dataQueryParam) => {
      return `${oddsServicePath}/search/odds?${dataQueryParam}`;
    },


    getRacebookIframeUrl : (dataQueryParam) => {
      return `${memberServicePath}/horse-racing/get-hr-iframe-url?${dataQueryParam}`;
    },

    getRacebookAuth : () => {
      return `${memberServicePath}/horse-racing/get-racebook-auth`;
    },

    getDigitalSportsTechIntegrationIframeUrl : (dataQueryParam) => {
      return `${memberServicePath}/iframe/get-iframe-url?${dataQueryParam}`;
    },
    
    getHrPlaceBetsUrl: () => '/racebook-placement/api/place-bets',

    getLimitBetUrl: () => `${memberServicePath}/horse-racing/limit-bet`,

    updateFingerPrintId: (dataQueryParam) => {
      return `${memberServicePath}/finger-print?${dataQueryParam}`;
    },

    getPromotionSurvey: (surveyId)  => {
        return `${memberServicePath}/promotion-survey/get-question?surveyId=${surveyId}`;
    },

    submitPromotionSurvey: () =>{
        return `${memberServicePath}/promotion-survey/submit-survey`;
    },

    getSportsbookFavoriteByUserId: () =>{
        return `${memberServicePath}/sportsbook-favorite/get-sports-book-favorite-by-user-id`
    },

    updateSportsbookFavoriteByUserId: () => {
        return `${memberServicePath}/sportsbook-favorite/update-sports-book-favorite-by-user-id`
    },

    getHorseRacingTokenUrl: () => `${memberServicePath}/horse-racing/get-token?userCode`,
	  
    getSportPeriodDesc: () =>{
      return `${oddsServicePath}/odds/periods`;
    },
    registerParticipantByCampaignId: function () {
      return `${memberServicePath}/campaign/participant`;
    },
    getBoardsByCampaignId: function (campaignId) {
      return `${memberServicePath}/campaign/board/${campaignId}`;
    },
    getScoresByCampaignId: function (campaignId) {
      return `${memberServicePath}/campaign/score/${campaignId}`;
    },
    getParticipantByCampaignId: function (campaignId) {
      return `${memberServicePath}/campaign/participant/${campaignId}`;
    },

    /**
    * 
    * Casino - get game by path to launch
    */
    getCasinoGameByPath: (casinoFilter) => {
      return `${memberServicePath}/casino/get-game-by-path?${casinoFilter}`;
    },

    getWebSocketURL: () => {
      return `wss://${window.location.hostname}/sports-websocket/ws`
    },
    
    getTeamStatsURL: (params) => {
        return `${oddsServicePath}/compact/matchup?${params}`
    },

    getPrestigeClubURL: (params) => {
      return `${memberServicePath}/prestige-club?${params}`;
    },
    
    getMatchupNavigation: (params) => {
      return `${oddsServicePath}/compact/matchup-navigation?${params}`
    },
    /**
     *  Multi-factor Authentication (MFA) 
     * 
     */
    getMfaSettingInfo: () => {
        return `${memberServicePath}/account/otp/getMfaSettingInfo`
    },
    setMfaMethodType: (params) => {
        return `${memberServicePath}/account/otp/setMfaMethodType?${params}`
    },
    getQRCode: () => {
        return `${memberServicePath}/account/otp/initQr`
    },
    getSecretKey: () => {
        return `${memberServicePath}/account/otp/initQrOtpCode`
    },
    saveQrOtp: (params) => {
        return `${memberServicePath}/account/otp/saveQrOtp?${params}`
    },
    getDGGameDispatcherUrl: (params) => {
      return `${memberServicePath}/getDGGameDispatcherUrl?${params}`
    },
    getUpdateReasonDpFailedURL: (params) => {
      return `${memberServicePath}/dp/floaded?reason=${params}`
    },
    getDPIframeURL: (params) => `${window.env.dynamicParameterIframeUrl}?${params}`
}


export default APIS;



// WEBPACK FOOTER //
// ./src/app/common/APIs.js